import {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react'

const NoticeStateCalifornia = forwardRef(({ data, company, refToPrint }, ref) => {

    const [requestReceiptCopy, setRequestReceiptCopy] = useState(data?.requestReceiptCopy ?? false)

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                    requestReceiptCopy,
                },
            }
        },
    }))

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md">
            <div ref={refToPrint} className="rounded-2xl space-y-6 text-gray-900 text-base leading-relaxed">
                <h2 className="text-2xl font-bold">
                    NOTICE REGARDING BACKGROUND CHECKS PER CALIFORNIA LAW
                </h2>

                <p>
                    {company?.name}, the
                    "Company," intends to obtain information about you for employment
                    screening purposes from a consumer reporting agency. Thus, you can
                    expect to be the subject of "investigative consumer reports" obtained
                    for employment purposes. Such reports may include information about your
                    character, general reputation, personal characteristics and mode of
                    living. With respect to any investigative consumer report from an
                    investigative consumer reporting agency ("ICRA"), the Company may
                    investigate the information contained in your employment application and
                    other background information about you, including but not limited to
                    obtaining a criminal record report, verifying references, work history,
                    your social security number, your educational achievements, licensure,
                    and certifications, your driving record, and other information about
                    you, and interviewing people who are knowledgeable about you. The
                    results of this report may be used as a factor in making employment
                    decisions. The source of any investigative consumer report (as that term
                    is defined under California law) will be{" "}
                    <a
                        href="https://verifiedid.co"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        VerifiedID
                    </a>
                    ,{" "}
                    <a href="tel:+18887182597" className="text-blue-600 underline">
                        (888) 718-2597
                    </a>
                    , 11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA,{" "}
                    <a
                        href="https://verifiedid.co"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://verifiedid.co
                    </a>
                    . The Company agrees to provide you with a copy of an investigative
                    consumer report when required to do so under California law.
                </p>

                <p>
                    Under California Civil Code section 1786.22, you are entitled to find
                    out what is in the ICRA's file on you with proper identification, as
                    follows:
                </p>

                <ul className="list-disc list-inside space-y-2">
                    <li>
                        In person, by visual inspection of your file during normal business
                        hours and on reasonable notice. You also may request a copy of the
                        information in person. The ICRA may not charge you more than the
                        actual copying costs for providing you with a copy of your file.
                    </li>
                    <li>
                        A summary of all information contained in the ICRA's file on you that
                        is required to be provided by the California Civil Code will be
                        provided to you via telephone, if you have made a written request,
                        with proper identification, for telephone disclosure, and the toll
                        charge, if any, for the telephone call is prepaid by or charged
                        directly to you.
                    </li>
                    <li>
                        By requesting a copy be sent to a specified addressee by certified
                        mail. ICRAs complying with requests for certified mailings shall not
                        be liable for disclosures to third parties caused by mishandling of
                        mail after such mailings leave the ICRAs.
                    </li>
                </ul>

                <p>
                    "Proper Identification" includes documents such as a valid driver's
                    license, social security account number, military identification card,
                    and credit cards. Only if you cannot identify yourself with such
                    information may the ICRA require additional information concerning your
                    employment and personal or family history in order to verify your
                    identity.
                </p>

                <p>
                    The ICRA will provide trained personnel to explain any information
                    furnished to you and will provide a written explanation of any coded
                    information contained in files maintained on you. This written
                    explanation will be provided whenever a file is provided to you for
                    visual inspection. You may be accompanied by one other person of your
                    choosing, who must furnish reasonable identification. An ICRA may
                    require you to furnish a written statement granting permission to the
                    ICRA to discuss your file in such person's presence.
                </p>

                <div className="flex items-start space-x-2">
                    <input
                        type="checkbox"
                        checked={requestReceiptCopy}
                        onChange={(event) => setRequestReceiptCopy(!requestReceiptCopy)}
                        id="report-copy-request"
                        className="mt-1"
                        required
                    />
                    <label htmlFor="report-copy-request" className="text-gray-900">
                        Please check this box if you would like to receive a copy of an
                        investigative consumer report at no charge if one is obtained by the
                        Company whenever you have a right to receive such a copy under
                        California law.
                    </label>
                </div>
            </div>
        </div>
    )

})

export default NoticeStateCalifornia
